export default __webpack_public_path__ + "static/media/Desktop.550ca518.jpg";